<template>
  <div>
    <BaseModalHeader>
      <BaseHeading :semantic-level="2" :display-level="1">
        Nachricht an {{ alternativeContact.firstName }} {{ alternativeContact.lastName }}
      </BaseHeading>
    </BaseModalHeader>
    <BaseModalContent>
      <BaseText>
        Hallo {{ alternativeContact.firstName }} {{ alternativeContact.lastName }},
      </BaseText>
      <BaseText>
        {{ contactInfo.firstName }} {{ contactInfo.lastName }} hat uns Ihre Kontaktdaten zur Abstimmung und Durchführung eines Servicetermins gegeben. Wir wurden von der ista Deutschland GmbH beauftragt Servicearbeiten im unten stehenden Objekt durchzuführen.
      </BaseText>
      <Spacer :mt="4" />
      <BaseHeading :semantic-level="3" color="turquoise">
        <BaseIcon icon="iconInfo" color="turquoise" />
        Auftragsnummer
      </BaseHeading>
      <BaseText>{{ workOrderId }}</BaseText>
      <Spacer :mt="4" />
      <BaseHeading :semantic-level="3" color="turquoise">
        <BaseIcon icon="iconCal" :color="'turquoise'" />
        Datum
      </BaseHeading>
      <BaseText>{{ timeslot.day }}</BaseText>
      <BaseText>zwischen {{ timeslot.time }} Uhr</BaseText>
      <Spacer :mt="4" />
      <BaseHeading :semantic-level="3" color="turquoise">
        <BaseIcon icon="iconTime" color="turquoise" />
        Erwartete Dauer
      </BaseHeading>
      <BaseText>ca. 25 Minuten</BaseText>
      <Spacer :mt="4" />
      <BaseHeading :semantic-level="3" color="turquoise">
        <BaseIcon icon="iconLocation" color="turquoise" />
        Wo
      </BaseHeading>
      <BaseText>{{ address }}</BaseText>
      <Spacer :mt="4" />
      <BaseHeading v-if="showActivities" :semantic-level="3" color="turquoise">
        <BaseIcon icon="iconWench" color="turquoise" />
        Geplante Arbeiten
      </BaseHeading>
      <BaseText v-if="showActivities">
        {{ activities }}
      </BaseText>
      <Spacer :mt="4" />
      <BaseText>
        <span>Bitte geben Sie uns im</span>
        <BaseLink :url="childShortUrl">
          {{ }} Terminierungsportal
        </BaseLink><span>{{ }} eine Rückmeldung dazu, ob Sie den Termin wahrnehmen können. Alternativ haben Sie dort die Möglichkeit, den Termin zu verschieben.</span>
      </BaseText>
      <Spacer :mt="4" />
      <BaseLink url="https://www.istaexpress.de/datenschutz.html" external>
        Unsere Datenschutzbestimmungen finden Sie hier.
      </BaseLink>
      <Spacer :mt="4" />
      <BaseText>Viele Grüße</BaseText>
      <BaseText>Ihr Team vom ista Express Service</BaseText>
    </BaseModalContent>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { isEmpty } from 'lodash-es'
import type {
  AlternativeContact,
  FormattedTimeslot
} from '~/terminierungsportal/types/appointmentTypes'
import { useAppointmentStore } from '~/terminierungsportal/stores/appointment'
import BaseModalHeader from '~/base/components/modal/ModalHeader.vue'
import BaseModalContent from '~/base/components/modal/ModalContent.vue'
import BaseHeading from '~/base/components/heading/Heading.vue'
import BaseText from '~/base/components/text/Text.vue'
import BaseIcon from '~/base/components/icon/Icon.vue'
import Spacer from '~/base/components/spacer/Spacer.vue'
import BaseLink from '~/base/components/link/Link.vue'
import type { ContactInfo } from '~/base/types/contact/contact'

const appointmentStore = useAppointmentStore()

const contactInfo = computed((): ContactInfo => {
  return appointmentStore.contactInfo
})

const showActivities = computed((): boolean => {
  return !isEmpty(activities.value)
})

const timeslot = computed((): FormattedTimeslot => {
  return appointmentStore.formattedTimeslot
})

const workOrderId = computed((): string => {
  return appointmentStore.appointment.workOrderId
})

const alternativeContact = computed((): AlternativeContact => {
  return appointmentStore.alternativeContact
})

const activities = computed((): string => {
  return appointmentStore.appointment.activities
})

const address = computed((): string => {
  return appointmentStore.formattedAddress
})

const childShortUrl = computed((): string => {
  return appointmentStore.appointment.childShortUrl
})
</script>
